import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/store';
import { getLanguageDirection } from '../../i18n/config';
import UserProfileFooter from '../user-profile-footer/user-profile-footer';
import CaseListView from './CaseListView';
import ChatListView from './ChatListView';
// DELETED: import CourtResearchListView from './CourtResearchListView';
import SidebarHeader from './SidebarHeader';
import SidebarTabs from './SidebarTabs';

/**
 * Sidebar component with cases and chats management
 */
const Sidebar = () => {
  const { i18n } = useTranslation();
  const activeSidebarTab = useAppSelector(state => state.UIReducer.activeSidebarTab);
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  return (
    <div
      className={`
        h-full w-full bg-background 
        ${isRTL ? 'border-l' : 'border-r'} border-border
        shadow-sm relative z-10 flex flex-col
      `}
      dir={getLanguageDirection(i18n.language)}
    >
      {/* Logo Header */}
      <SidebarHeader />

      {/* Navigation Tabs */}
      <SidebarTabs />

      {/* Tab Content */}
      <div className="flex-1 pt-2 pb-4 px-4 flex flex-col min-h-0 overflow-hidden">
        {activeSidebarTab === 'cases' && <CaseListView />}
        {activeSidebarTab === 'chats' && <ChatListView />}
        {/* DELETED: {activeSidebarTab === 'courtResearch' && <CourtResearchListView />} */}
      </div>

      {/* User Profile Section */}
      <UserProfileFooter />
    </div>
  );
};

export default Sidebar;
